export function swapKeyValuePair(start) {
  Object.keys(start)
    .filter(start.hasOwnProperty.bind(start))
    .reduce((obj, key) => {
      obj[obj[key]] = key;
      return obj;
    }, {});
}


// WEBPACK FOOTER //
// ./src/utils/object/swap-key-value.utils.ts